module.exports = __webpack_public_path__ + "static/media/spinner.bf5beb7e.svg";